import React, {useState, useEffect} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { DRAWER_BACKGROUND } from "../../constants/styles";

export default function RightDrawer({ open, title, onClose, children, width }) {

const getWidth = () => {
	if(width){
		return width;
	}
	else{
		return '600px';
	}
}
	
  return (
    <>
      {/* OVERLAY */}
      {open && <div style={overlay} onClick={onClose} />}

      {/* DRAWER */}
      <div
        style={{
          ...drawer,
		  width:getWidth(),
          transform: open ? "translateX(0)" : "translateX(100%)"
        }}
      >
        {/* HEADER */}
        <div style={header}>
          <div style={titleStyle}>{title}</div>
          <div style={closeBtn} onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
        </div>

        {/* CONTENT */}
        <div style={content}>
          {children || <div>Drawer content goes here...</div>}
        </div>
		
		<div
		    style={closeCircle}
		    onClick={onClose}
		    onMouseEnter={e => {
		      e.currentTarget.style.background = "#262626";
		      e.currentTarget.style.color = "#fff";
		      e.currentTarget.style.transform = "translateY(-50%) scale(1.05)";
		    }}
		    onMouseLeave={e => {
		      e.currentTarget.style.background = "#1a1a1a";
		      e.currentTarget.style.color = "#ccc";
		      e.currentTarget.style.transform = "translateY(-50%) scale(1)";
		    }}
		  >
		    ✕
		  </div>
      </div>
	 
    </>
  );
}

/* ================= STYLES ================= */


const closeCircle = {
  position: "absolute",
  left: "-18px",              // 🔥 pulls it outside drawer
  top: "50%",
  transform: "translateY(-50%)",
  zIndex:'3',
  width: "36px",
  height: "36px",
  borderRadius: "50%",

  background: "#1a1a1a",
  color: "#ccc",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  cursor: "pointer",
  fontSize: "14px",

  boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
  border: "1px solid rgba(255,255,255,0.08)",

  transition: "all 0.2s ease"
};

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.25)",
  zIndex: 99
};

const drawer = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100vh",
  background: DRAWER_BACKGROUND,
 backdropFilter: "blur(10px)",
 WebkitBackdropFilter: "blur(12px)",
 boxShadow: "-10px 0 30px rgba(0,0,0,0.6)",
  color: "#e6e6e6",
  zIndex: 1000,
  display: "flex",
  flexDirection: "column",
  transition: "transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)",
  oveflowY:'hidden'
};

const header = {
  height: "60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 16px",
  borderBottom: "1px solid #eee"
};

const titleStyle = {
  fontSize: "16px",
  fontWeight: "600"
};

const closeBtn = {
  cursor: "pointer",
  fontSize: "16px",
  color: "#666"
};

const content = {
  flex: 1,
  padding: "16px",
  overflowY: "auto"
};